import {
  TrackerAbstract,
  TrackerUserAbstract,
} from '../trackers/clients/@interfaces/Tracker.interface';
import { TTrackProperties } from '../trackers/clients/@types/Trackers.types';
import { amplitudeClient } from '../trackers/clients/amplitude';
import { mixpanelClient } from '../trackers/clients/mixpanel';

const trackers = [amplitudeClient, mixpanelClient];

const init = (): void => {
  trackers.forEach((tracker: TrackerAbstract) => tracker.init());
};

const identify = (user?: TrackerUserAbstract): void => {
  trackers.forEach((tracker: TrackerAbstract) => tracker.identify(user));
};

const sendEvent = ({
  eventName,
  properties,
  application,
}: TTrackProperties): void => {
  trackers.forEach((tracker: TrackerAbstract) =>
    tracker.track({ eventName, properties, application })
  );
};

const metrics = {
  init,
  identify,
  sendEvent,
};

export default metrics;
